const commonQuestions=[
    {
        title:'Our company',
        answers:[
            'how we work','why insure?','check price','reviews'
        ]
    },
    {
        title:'help me',
        answers:[
            'faq','terms of use','privacy policy','cookies'
        ]
    },
    {
        title:'conctact',
        answers:[
            'sales','support','live chat'
        ]
    },
    {
        title:'others',
        answers:[
            'careers','press','licenses'
        ]
    },
]

export default commonQuestions;